export default "__VITE_ASSET__dVO53z3___"